// For full API documentation, including code examples, visit https://wix.to/94BuAAs
import wixLocation from 'wix-location';
$w.onReady(function () {
	//TODO: write your page related code here...
	//https://www.wix.com/playground/blog/post/
	//FEF7F5
	if (typeof $w('#headerstrip').hide === 'function') {
		if(wixLocation.path[2] ==='post'){
			$w('#headerstrip').show();
			
		} else {
			$w('#headerstrip').hide(); //https://static.wixstatic.com/media/827c6d_55aed1e00424415b9ac36e381469554f~mv2.png/v1/fill/w_10,h_10/10x10pink.png'
		}
	}	
});